export default "__VITE_ASSET__DeH$uzd___"